import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Retry transient failures only. A 4xx is deterministic — retrying it just
 * delays the error state, during which the UI keeps rendering the previous
 * result set as though the new request had succeeded.
 */
function retry_transient_only(failure_count: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failure_count < 1;
}

export const query_client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: retry_transient_only,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
